"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDonationRenewalMockData = exports.FROALA_DONATION_RENEWAL_NOTE_BODY = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const icons_1 = require("../icons");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const FROALA_PARAGRAPH_STYLE = "width:100%;margin:0px;box-sizing:inherit;color:rgb(0, 0, 0);line-height:1.5;";
const EMPTY_LINE = "<p><br></p>";
exports.FROALA_DONATION_RENEWAL_NOTE_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Hello John,</p>
${EMPTY_LINE}
<p style="${FROALA_PARAGRAPH_STYLE}">Your recurring donation supporting The Cool Foundation will renew on January 15, 2026.</p>
${EMPTY_LINE}
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>Renewal amount:</strong> $25.00<br/><strong>Payment method:</strong> Card</p>
${EMPTY_LINE}
<p style="${FROALA_PARAGRAPH_STYLE}">Thank you for your continued support!</p>
${EMPTY_LINE}
<p style="${FROALA_PARAGRAPH_STYLE}"><strong>The Cool Foundation Team</strong></p>`;
const buildDonationRenewalMockData = ({ orgName, color, isDarkMode, body, locale = "en", subject = "Your recurring donation renews soon", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme,
        iconZeffyLogo,
        lang: locale,
        subject,
        orgName: orgName || "Bright Futures Foundation",
        message: body || exports.FROALA_DONATION_RENEWAL_NOTE_BODY,
    };
};
exports.buildDonationRenewalMockData = buildDonationRenewalMockData;
